/* @flow */

import $ from 'jquery';
import moment from 'moment';
import get from 'lodash/get';
import range from 'lodash/range';
import swal from '../utils/swal';
import { exibirToastError } from '../utils/alertas';
import api from '../utils/api';
import badgeStatus from './badgeStatus';
import formatarRealComMoeda from '../utils/formatar-real-com-moeda';
import getInputPorId from '../utils/get-input-por-id';
import { type Empresa } from '../empresa/types';
import { type ServicoPagamento } from '../empresa/historico-financeiro/types';

const thead = `
    <thead>
        <tr>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Data
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Plano
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Valor do plano
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Status
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Código
                    </font>
                </font>
            </th>
        </tr>
    </thead>
`;

const tbody = (mensalidades: ServicoPagamento[]) => `
    <tbody>
        ${mensalidades.map(mensalidade => (`
            <tr>
                <th scope="row">
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${moment(mensalidade.date).format('Y/MM/DD H:mm:ss')}
                        </font>
                    </font>
                </th>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${mensalidade.name}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${formatarRealComMoeda(mensalidade.valor_plano)}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${badgeStatus(mensalidade.status)}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${mensalidade.code}
                        </font>
                    </font>
                </td>
            </tr>
        `)).join('')}
    </tbody>
`;

const semFuncionarios = `
    <div class="alert m-alert alert-warning">
        <div class="m-alert__text">Nenhum resultado encontrado</div>
    </div>`;

const content = (mensalidades: ServicoPagamento[]) => `
    <br/>
    <div
        class="m-section m-scrollable m-scrollable--track"
        data-scrollable="true"
        style="max-height: 400px""
    >
        <div class="m-section__content">
            <table class="table m-table m-table--head-bg-primary">
                ${thead}
                ${tbody(mensalidades)}
            </table>
            ${mensalidades.length < 1 ? semFuncionarios : ''}
        </div>
    </div>
`;

const dataList = () => {
    const anoInicio = moment('2017');
    const anoAtual = moment().format('Y');
    const anos = range(Number(anoAtual) - Number(anoInicio.format('Y')), 0);

    return `
    <input
        list="years"
        class="swal2-input"
        id="input-date"
        value="${anoAtual}"
        placeholder="Exemplo: ${anoAtual}"
        type="text"
        style="display: flex;"
    >
    <datalist id="years">
        ${anos
        .map(index => `
                <option selected value="${moment('2017').add(index, 'year').format('Y')}">
            `)
        .join('')}
    </datalist>
`;
};

const gridMensalidades = async (empresa: Empresa) => {
    await swal.fire({
        title: 'Selecione o ano',
        scrollbarPadding: false,
        confirmButtonColor: '#36a3f7',
        html: dataList(),
        focusConfirm: false,
        preConfirm: async () => {
            try {
                const date = getInputPorId('input-date').value;

                const regex = date.match(/^\d{4}$/);

                if (!regex) {
                    swal.showValidationMessage('Formato inválido, digite apenas o ano');
                    return;
                }

                const ano = regex[0];

                if (moment(ano).add('years', '1').format('Y') > moment().format('Y')) {
                    swal.showValidationMessage('Ano atual é o limite');
                    return;
                }

                const { data: mensalidades } = await api
                    .buscarMensalidadesPorEmpresaId(empresa.id, {
                        dataInicial: moment(ano).add('years', '1').format('Y-01-01'),
                        dataFinal: moment(ano).add('years', '1').format('Y-12-31'),
                    });

                $(document).ready(() => {
                    window.mApp.init();
                });

                await swal.fire({
                    title: `Mensalidades da empresa ${empresa.fantasia}`,
                    width: 1300,
                    scrollbarPadding: false,
                    confirmButtonColor: '#36a3f7',
                    html: content(mensalidades),
                    focusConfirm: false,
                });
            } catch (error) {
                exibirToastError(get(
                    error,
                    'response.data.message',
                    'Algo deu errado',
                ));
            }
        },
    });
};

export default gridMensalidades;
